export default "__VITE_ASSET__bb1d4f79__"